export default function getStorySharingUrl(state) {
  const playerOptionsStorySharingUrl = state.playerOptions.storySharingUrl;
  const publishSettingsStorySharingUrl =
    state.storyPublishSettings.storySharingUrl;

  const url = new URL(window.location.href);
  url.pathname = url.pathname.split("/").slice(0, 3).join("/");

  return (
    playerOptionsStorySharingUrl ||
    publishSettingsStorySharingUrl ||
    url.toString()
  );
}
